import { Controller } from "stimulus";

export default class VoucherImageController extends Controller {
  static targets = ["value", "salonLogo"]

  get amountSpanTemplate() {
    return this.data.get("amount-span-template");
  }

  addSalonLogo() {
    let logoUrl = this.data.get('salon-logo')
    let voucherStyle = this.data.get('voucher-style')
    if (logoUrl != '' && logoUrl != null && voucherStyle === 'SALON_LOGO') {
      this.salonLogoTarget.href.baseVal = logoUrl;
    }
  }

  updateGiftCardImageAmount(event) {
    const valueHTML = this.amountSpanTemplate.replace('AMOUNT', event.voucherValue.toFixed(2));
    this.valueTarget.innerHTML = valueHTML;
  }
}
